import React, { useState } from 'react'
import AnnouncementView from './AnnouncementView'
import type { Announcement } from './announcementQueue'
import { openCta } from './announcementQueue'
import type { useAnnouncements } from './useAnnouncements'

/**
 * An announcement opened from history: the header button with `resourceCenterNext` off, the
 * resource center panel with it on (#25353). One copy, so a fix reaches both sides of the flag.
 *
 * Its own state, not `engagementSurfaces`, as the header's always was: it never mounts a second
 * `AnnouncementCenter`, so no unmount cleanup can clear another instance's dialog (#25452).
 */
export function useHistoryAnnouncement(mark: ReturnType<typeof useAnnouncements>['mark']) {
  const [open, setOpen] = useState<Announcement | null>(null)

  const show = (announcement: Announcement) => {
    setOpen(announcement)
    mark(announcement, 'viewed', 'history')
  }

  const view = open ? (
    <AnnouncementView
      announcement={open}
      mode="modal"
      onClose={() => setOpen(null)}
      onCta={() => {
        mark(open, 'ctaClicked', 'history')
        openCta(open)
        setOpen(null)
      }}
    />
  ) : null

  return { show, view }
}
